import { get } from "../../../common/api-service";

const UserAPI = {
    async getCompanyUserStats(companyId: string) {
        let url = `/user/stats-by-company/${companyId}`;
        return await get(url);
    },

    async getDealershipUserStats() {
        let url = `/user/stats-by-dealership`;
        return await get(url);
    },
};

export default UserAPI;
